import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";

import { SwiperSlide } from "swiper/react";
import "swiper/modules/grid/grid.min.css";
import { Grid, Pagination, Navigation } from "swiper";

import { EMPTY_STRING, messages, SPACE } from "../../../constants";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play.svg";
import { ReactComponent as QuotationIcon } from "../../../assets/icons/quotation.svg";
import { ReactComponent as ChevronLeftIcon } from "../../../assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "../../../assets/icons/chevron-right.svg";
import { normalizeValue, isVideoUrl } from "../../../shared";
import useResponsiveView from "../../../shared/hooks/useResponsiveView";
import IconButton from "../../../shared/components/IconButton/IconButton";
import SliderWrapper from "../../../shared/components/Slider/SliderWrapper";
import ProfileImage from "../../../shared/components/ProfileImage/ProfileImage";
import MediaPreviewModal from "../../../shared/components/Modal/MediaPreviewModal";
import ShutterbReviews from "../../../shared/components/ShutterbReviews/ShutterbReviews";
import {
  shutterbProfileActions,
  eventBookingActions,
} from "../../../redux/actions";
import ShutterBSliderMobileView from "./ShutterBSliderMobileView";

const ShutterBProfileView = (props) => {
  const {
    profileData,
    hideReserveButton,
    handleShutterBClick,
    isSelected,
    setIsProfileViewShutterBSelected,
    isFromShutterbSelectionPage,
  } = props;

  const { id } = useParams();
  const { t } = useTranslation("common");
  const { isLessThan } = useResponsiveView();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (id) {
      props.getShutterBProfile(id);
    }
    // eslint-disable-next-line
  }, []);

  const handleClick = (shutterBId) => {
    let shutterB = null;

    if (props.isDraftEvent) {
      const draftEvent = props.formState.find(
        (e) => e.id === props.selectedEventId
      );
      shutterB = draftEvent?.orderItems?.find(
        (item) => item.sbUserId === shutterBId
      );
    } else {
      const event = props.availableShutterBs.find(
        (e) => e.eventId === props.selectedEventId
      );
      shutterB = event?.items?.find((item) => item.sbUserId === shutterBId);

      if (isFromShutterbSelectionPage) {
        shutterB = props.availableShutterBs[0]?.items?.find(
          (item) => item.sbUserId === shutterBId
        );
      }
    }

    if (shutterB) {
      handleShutterBClick(props.selectedEventId, shutterB);
      setIsProfileViewShutterBSelected(!isSelected);
    }

    props.setIsProfileViewShow(false);
  };

  const getGalleryItems = () => {
    const baseUrl = process.env.REACT_APP_S3_BASE_URL_PORTFOLIO;
    const galleries = profileData.sbportfolios?.[0]?.gallery ?? [];

    return galleries.map((gallery) => ({
      ...gallery,
      url: gallery.imageUrl
        ? `${baseUrl}/${gallery.imageUrl}`
        : gallery.imageUrl,
      thumbnailUrl: gallery.imageThumbnailUrl
        ? `${baseUrl}/${gallery.imageThumbnailUrl}`
        : gallery.imageThumbnailUrl,
    }));
  };

  return (
    <div className="shutterb-profile-contianer mt-4">
      <div className="row">
        <div className="col-lg-8">
          <div className="d-flex flex-row align-items-start px-0 px-md-5">
            <div className="flex-shrink-0 mr-4 mb-0">
              <ProfileImage
                imageUrl={
                  profileData?.sbportfolios?.[0]?.profileImageUrl ||
                  EMPTY_STRING
                }
              />
            </div>
            <div>
              <p className="sb-name text-break my-1 mb-0">
                {normalizeValue(profileData?.firstName) +
                  normalizeValue(SPACE) +
                  normalizeValue(profileData?.lastName)}
              </p>

              <div className="line-height-normal">
                <span className="sb-heading">reviews:</span>
                <span className="sb-info ml-2">
                  {profileData.averageReview
                    ? Number(profileData.averageReview)?.toFixed(1)
                    : "0.0"}
                  /5
                </span>
              </div>

              <div className="line-height-normal">
                <span className="sb-heading">phone:</span>
                <span className="sb-info text-break ml-2">
                  {profileData.device?.isActive
                    ? profileData.device?.deviceName
                    : EMPTY_STRING}
                </span>
              </div>

              {profileData?.sbportfolios?.[0]?.additionalEquipment && (
                <div className="line-height-normal">
                  <span className="sb-heading">additional equipment:</span>
                  <span className="sb-info text-break ml-2">
                    {profileData.sbportfolios?.[0]?.additionalEquipment}
                  </span>
                </div>
              )}

              <div className="line-height-normal">
                <span className="sb-heading">languages spoken:</span>
                <span className="sb-info text-break ml-2">
                  {`English${
                    profileData?.sbportfolios?.[0]?.language &&
                    profileData?.sbportfolios?.[0]?.language !== "null"
                      ? `, ${profileData?.sbportfolios?.[0]?.language}`
                      : EMPTY_STRING
                  }`}
                </span>
              </div>
            </div>
          </div>
        </div>

        {hideReserveButton
          ? null
          : !isLessThan(576) &&
            profileData?.id && (
              <div className="col-lg-4 text-right">
                <button
                  className="button-common button-fill mt-2 px-2 ellipsis-text"
                  onClick={() => handleClick(profileData?.id)}
                >
                  {isSelected ? messages.UNRESERVE : messages.RESERVE}
                </button>
              </div>
            )}
      </div>

      <div className="row">
        <div className="col-12">
          <p className="sb-bio my-3 px-0 px-md-5">
            {profileData.sbportfolios?.[0]?.bio || EMPTY_STRING}
          </p>
        </div>

        <div className="col-12">
          {isLessThan(601) ? (
            <ShutterBSliderMobileView profileData={profileData} />
          ) : (
            <div className="sutterb-image-slider">
              {getGalleryItems()?.length > 0 && (
                <SliderWrapper
                  slidesPerView={isLessThan(751) ? 2 : isLessThan(1061) ? 3 : 4}
                  spaceBetween={15}
                  gridRows={2}
                  showPagination
                  modules={[Grid, Pagination, Navigation]}
                  paginationOptions={{
                    clickable: true,
                  }}
                  PrevIcon={ChevronLeftIcon}
                  NextIcon={ChevronRightIcon}
                  prevButtonClass="shutterb-swiper-button shutterb-swiper-button-prev"
                  nextButtonClass="shutterb-swiper-button shutterb-swiper-button-next"
                >
                  {getGalleryItems().map((gallery, index) => {
                    const isVideo = isVideoUrl(gallery.imageUrl);

                    const imagePath = isVideo
                      ? gallery.thumbnailUrl || gallery.url || EMPTY_STRING
                      : gallery.url || gallery.thumbnailUrl || EMPTY_STRING;

                    return (
                      <SwiperSlide key={index}>
                        <div className="video-thumbnail-wrapper w-100">
                          <img
                            className="w-100 video-thumbnail"
                            src={imagePath}
                            alt={`p-${index}`}
                            onClick={() => {
                              setCurrentIndex(index);
                              setIsModalOpen(true);
                            }}
                          />
                          {isVideo && (
                            <div className="play-icon-overlay">
                              <IconButton
                                icon={<PlayIcon />}
                                width="35px"
                                height="35px"
                                className="shutterb-profile-play-icon"
                                handleClick={() => {
                                  setCurrentIndex(index);
                                  setIsModalOpen(true);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </SliderWrapper>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="review-container position-relative mt-5">
        <div className="text-center">
          <h3 className="heading mb-2">{t("reviews")}</h3>
          <p className="sub-heading">
            {props.sbReviews.length ? props.sbReviews.length : 0} hosts have
            provided reviews
          </p>
        </div>
        {props.sbReviews &&
          props.sbReviews.length > 0 &&
          props.sbReviews.map((review, index) => (
            <React.Fragment key={index}>
              <ShutterbReviews review={review} />
            </React.Fragment>
          ))}

        <QuotationIcon className="quotation-icon" />
      </div>

      {hideReserveButton
        ? null
        : isLessThan(576) && (
            <div className="mobile-view-button g-2">
              <button
                className="button-common button-outline"
                onClick={() => props.handlePrevious()}
              >
                {messages.BACK}
              </button>

              <button
                className="button-common button-fill px-2 ellipsis-text"
                onClick={() => handleClick(profileData?.id)}
              >
                {isSelected ? messages.UNRESERVE : messages.RESERVE}
              </button>
            </div>
          )}

      <MediaPreviewModal
        isOpen={isModalOpen}
        currentIndex={currentIndex}
        mediaFiles={getGalleryItems()}
        setCurrentIndex={setCurrentIndex}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  sbReviews: state.shutterbProfile.sbReviews,
  isDraftEvent: state.eventBooking.isDraftEvent,
  profileData: state.shutterbProfile.profileData,
  selectedEventId: state.eventBooking.selectedEventId,
  availableShutterBs: state.eventBooking.availableShutterBs,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setIsProfileViewShow: (data) =>
    dispatch(eventBookingActions.setIsProfileViewShow(data)),
  getShutterBProfile: (id) =>
    dispatch(shutterbProfileActions.getShutterBProfile(id)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ShutterBProfileView));
